import React from "react";
import CompanyWrapper from "../UserModule/user.style";
import PageTitle from "components/common/PageTitle";
import ReportTable from "../../components/reportModule/ReportTable";
import { connect } from "react-redux";

const CompanyReport = (props) => {
  return (
    <CompanyWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          title="company report"
          className="plr-15"
          iconClass="fas fa-chart-bar"
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/dashboard")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>
      <div className="user-tbl">
        <ReportTable {...props} />
      </div>
    </CompanyWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.themeChanger,
  };
};

export default connect(mapStateToProps, null)(CompanyReport);
